import * as app from './appReducer'
import * as login from './loginReducer'
import * as master from './masterReducer'
import * as profile from './profileReducer'
export default Object.assign(app, login, master, profile)
